import type { JobDetailDto, JobDto } from "@grizzly/shared";
import { request } from "../http.js";

export const jobsApi = {
  listJobs: (
    params: { status?: string; customerId?: string; due?: string; search?: string } = {}
  ) => {
    const query = new URLSearchParams();
    query.set("limit", "100");
    if (params.status) query.set("status", params.status);
    if (params.customerId) query.set("customerId", params.customerId);
    if (params.due) query.set("due", params.due);
    if (params.search) query.set("search", params.search);
    return request<{ items: JobDto[] }>(`/jobs?${query.toString()}`);
  },
  getJob: (id: string) => request<{ job: JobDetailDto }>(`/jobs/${id}`),
  createJob: (input: object) =>
    request<{ job: JobDetailDto }>("/jobs", { method: "POST", body: input }),
  addJobOperation: (id: string, input: object) =>
    request<{ job: JobDetailDto }>(`/jobs/${id}/operations`, {
      method: "POST",
      body: input,
    }),
  addJobMaterial: (id: string, input: object) =>
    request<{ job: JobDetailDto }>(`/jobs/${id}/materials`, {
      method: "POST",
      body: input,
    }),
  releaseJob: (id: string) =>
    request<{ job: JobDetailDto }>(`/jobs/${id}/release`, { method: "POST", body: {} }),
  holdJob: (id: string, reason: string) =>
    request<{ job: JobDetailDto }>(`/jobs/${id}/hold`, {
      method: "POST",
      body: { reason },
    }),
  resumeJob: (id: string, note?: string) =>
    request<{ job: JobDetailDto }>(`/jobs/${id}/resume`, {
      method: "POST",
      body: { note },
    }),
  markJobReady: (id: string) =>
    request<{ job: JobDetailDto }>(`/jobs/${id}/mark-ready`, {
      method: "POST",
      body: {},
    }),
  completeJob: (id: string, force: boolean, note?: string) =>
    request<{ job: JobDetailDto }>(`/jobs/${id}/complete`, {
      method: "POST",
      body: { force, note },
    }),
  cancelJob: (id: string, note?: string) =>
    request<{ job: JobDetailDto }>(`/jobs/${id}/cancel`, {
      method: "POST",
      body: { note },
    }),
  raiseJobIssue: (id: string, input: object) =>
    request<{ job: JobDetailDto }>(`/jobs/${id}/issues`, { method: "POST", body: input }),
  resolveJobIssue: (id: string, issueId: string, note?: string) =>
    request<{ job: JobDetailDto }>(`/jobs/${id}/issues/${issueId}/resolve`, {
      method: "POST",
      body: { note },
    }),
  convertSalesOrder: (orderId: string, priority: string, dueDate?: string) =>
    request<{ jobs: JobDto[] }>(`/sales-orders/${orderId}/convert`, {
      method: "POST",
      body: { priority, dueDate },
    }),
};
